module.exports = __webpack_public_path__ + "static/media/sorry.42d2e3eb.mp3";